// @ts-nocheck
import { addToChainBefore, Handler, replaceInChain } from "@insite/client-framework/HandlerCreator";
import { ClearCartApiParameter } from "@insite/client-framework/Services/CartService";
import {
    getCartState,
    getCurrentCartState,
    hasProductsWithInvalidPrice,
} from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import loadCurrentCart from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCurrentCart";
import { CallClearCart, chain, LoadCart } from "@insite/client-framework/Store/Pages/Cart/Handlers/ClearCurrentCart";
import { CartModel } from "@insite/client-framework/Types/ApiModels";
import useCart from "@store/Framework/Common/Hooks/useCart";
import useCurrency from "@store/Framework/Common/Hooks/useCurrency";
import { dispatchEmptyCartEvent } from "@store/Framework/Services/AnalyticsService";

type HandlerType = Handler<
    {
        cartId?: string;
    },
    {
        apiParameter: ClearCartApiParameter;
    }
>;

export const StoreLoadCart: HandlerType = props => {
    props.dispatch(
        loadCurrentCart({
            onSuccess: () => {
                props.dispatch({
                    type: "Context/CompleteUpdatingCart",
                });
                props.dispatch({
                    type: "Pages/Cart/CompleteClearCart",
                });
                dispatchEmptyCartEvent();
            },
        }),
    );
};

replaceInChain(chain, LoadCart, StoreLoadCart);
